import { createSelector } from "reselect"
import { get } from "lodash"
import { computeEditingFilter, computeAddedFilters } from "helpers/filters"
import { computeChipSecuritiesIds } from "helpers/filters/chips"
import { computeFilterOns } from "helpers/filters/filter-ons"
import { classificationsMap, computeClassifications } from "helpers/classification"
import { computeSecuritiesDescriptors } from "helpers/securities"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getCurrency } from "modules/portfolio-root/selectors/portfolios"
import { getDate } from "./dates"
import { VIEW_TYPES } from "helpers/base"

export const getPortfolioFilters = state => get(state, "global.data.portfolioFilters.data")
const getEditing = state => get(state, "modules.intraday.editingFilter")
const getRawClassifications = (state) => get(state, "global.data.classifications.data.classifications")
export const getFilter = state => get(state, "modules.intraday.filter")
export const getClassificationsValues = (state) => get(state, "global.data.classificationsValues.data")
const getPortfolioSecuritiesDescriptors = (state) => get(state, "global.data.portfolioSecuritiesDescriptors.data")
export const getNormalization = state => get(state, "modules.intraday.normalization")
const getAssetType = () => "PORTFOLIO"
// we only support absolute mode for intraday
const getViewType = () => VIEW_TYPES.ABSOLUTE

export const getSecuritiesDescriptors = createSelector(
  [getPortfolioSecuritiesDescriptors],
  computeSecuritiesDescriptors,
)

export const getChipSecuritiesIds = createSelector(
  [getFilter],
  computeChipSecuritiesIds,
)

export const getClassifications = createSelector(
  [getRawClassifications, getDate],
  computeClassifications,
)

export const getFilterOns = createSelector(
  [getViewType, getPortfolioFilters, getFilter, getEditing, getTagCategories, getClassifications, getClassificationsValues, getAttributeCategories, getAssetType, getNormalization],
  computeFilterOns,
)

export const getEditingFilter = createSelector(
  [getFilter, getEditing, getFilterOns, getSecuritiesDescriptors],
  computeEditingFilter,
)

export const getClassificationsTiers = createSelector(
  [getRawClassifications, getDate],
  classificationsMap,
)

export const getAddedFilters = createSelector(
  [getFilter, getFilterOns, getTagCategories, getClassifications, () => {}, getSecuritiesDescriptors, getPortfolioFilters, getAttributeCategories, getCurrency],
  (filter, filterOns, tagCategories, classificationsMetas, classificationsValues, securitiesDescriptors, portfolioFilters, attributeCategories, currency) => {
    return computeAddedFilters(filter, filterOns, {
      securitiesDescriptors,
      classificationsInfos: {
        classificationsMetas,
        classificationsValues,
      },
      currency,
      tagCategories,
      portfolioFilters,
      attributeCategories,
    })
  },
)
